import React, { useState } from 'react';

const GenericField = ({ children, className }) => {
    const label = children[0];
    const inputContainer = children[1];

    const [isEditing, _setIsEditing] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const setIsEditing = (value) => {
        setIsHovered(value);
        _setIsEditing(value);
    };

    const onMouseOver = () => {
        setIsHovered(true);
    };
    const onMouseLeave = () => {
        setIsHovered(false);
    };

    const formatClassName = isEditing ? 'editing' : isHovered ? 'hover' : '';

    return (
        <div
            className={`field-input-group crm-editable-field-wrapper ${formatClassName} ${className}`}
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}>
            <div className='field-label'>{label}</div>
            <div className='field-value'>{React.cloneElement(inputContainer, { isEditing, setIsEditing, isHovered, setIsHovered })}</div>
        </div>
    );
};

export default GenericField;
